import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const LuxBg = ({ n }) => (
  <div
    aria-hidden="true"
    className="absolute inset-0 pointer-events-none"
    style={{
      zIndex: -1,
      backgroundImage: `linear-gradient(rgba(20,40,72,0.9), rgba(20,40,72,0.94)), url(/images/lux${n}.jpg)`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}
  />
);

export const SectionLabel = ({ num, text }) => (
  <div className="mono text-[13px] tracking-[0.3em] text-[#FFC631] mb-6" data-testid={`section-label-${num}`}>
    [{num}] — {text}
  </div>
);
